import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  const { FiFacebook, FiYoutube, FiInstagram, FiLinkedin } = FiIcons;

  const socialLinks = [
    { Icon: FiFacebook, href: 'https://www.facebook.com/profitlenseai' },
    { Icon: FiYoutube, href: 'https://www.youtube.com/@ProfitLenseai' },
    { Icon: FiInstagram, href: 'https://www.instagram.com/profitlense_ai/' },
    { Icon: FiLinkedin, href: 'https://www.linkedin.com/company/profitlense-ai/' }
  ];

  return (
    <footer className="border-t border-white/5 py-12 md:py-20 bg-navy-deep relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center relative z-10">
        <div className="mb-8 md:mb-10 group cursor-pointer">
          <img 
            src="https://i.postimg.cc/PJHcFz0Z/Profit-Lense-Ai-removebg-preview.png" 
            alt="ProfitLense.ai" 
            className="h-8 md:h-12 w-auto object-contain" 
          />
        </div>

        <div className="flex items-center gap-6 md:gap-10 mb-8 md:mb-12">
          {socialLinks.map(({ Icon, href }, i) => (
            <a 
              key={i} 
              href={href} 
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-body hover:text-brand-secondary transition-all transform hover:scale-125 hover:-translate-y-1"
            >
              <SafeIcon icon={Icon} className="text-xl md:text-2xl" />
            </a>
          ))}
        </div>

        <p className="text-text-body/60 text-xs md:text-sm mb-8 md:mb-10 font-medium tracking-wide text-center">
          © {new Date().getFullYear()} ProfitLense.ai — Precision AI Trading Platform.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-[9px] md:text-[10px] text-text-body/40 font-bold uppercase tracking-[0.2em] md:tracking-[0.3em] px-4 text-center">
          <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
          <span className="hidden md:inline text-white/5">•</span>
          <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          <span className="hidden md:inline text-white/5">•</span>
          <a href="#" className="hover:text-white transition-colors">Risk Disclosure</a>
        </div>
      </div>

      {/* Subtle bottom glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full md:w-1/2 h-1 bg-gradient-brand blur-md opacity-30"></div>
    </footer>
  );
}